export default __webpack_public_path__ + "public/icons/addTestCase.png?73b649a8dfd6f073e3293fa9a9480bb7";